import {
  ServiceMenuBreakTime,
  ServiceMenuOptionTime,
  ServiceMenuTimeRequired,
} from "@/apis/clients";
import { assertNever } from "@/utils/common";

export function convertServiceMenuTimeRequired(
  serviceMenuTimeRequired: ServiceMenuTimeRequired,
): number {
  switch (serviceMenuTimeRequired) {
    case ServiceMenuTimeRequired.MINUTES_15:
      return 15;
    case ServiceMenuTimeRequired.MINUTES_30:
      return 30;
    case ServiceMenuTimeRequired.MINUTES_45:
      return 45;
    case ServiceMenuTimeRequired.MINUTES_60:
      return 60;
    case ServiceMenuTimeRequired.MINUTES_75:
      return 75;
    case ServiceMenuTimeRequired.MINUTES_90:
      return 90;
    case ServiceMenuTimeRequired.MINUTES_120:
      return 120;
    case ServiceMenuTimeRequired.MINUTES_150:
      return 150;
    case ServiceMenuTimeRequired.MINUTES_180:
      return 180;
    case ServiceMenuTimeRequired.MINUTES_210:
      return 210;
    case ServiceMenuTimeRequired.MINUTES_20:
      return 20;
    case ServiceMenuTimeRequired.MINUTES_25:
      return 25;
    case ServiceMenuTimeRequired.MINUTES_35:
      return 35;
    case ServiceMenuTimeRequired.MINUTES_40:
      return 40;
    case ServiceMenuTimeRequired.MINUTES_50:
      return 50;
    case ServiceMenuTimeRequired.MINUTES_55:
      return 55;
    case ServiceMenuTimeRequired.MINUTES_70:
      return 70;
    case ServiceMenuTimeRequired.MINUTES_80:
      return 80;
    case ServiceMenuTimeRequired.MINUTES_100:
      return 100;
    case ServiceMenuTimeRequired.MINUTES_240:
      return 240;
    case ServiceMenuTimeRequired.MINUTES_300:
      return 300;
    case ServiceMenuTimeRequired.MINUTES_0:
      return 10;
    default:
      assertNever(serviceMenuTimeRequired);
  }
}

/**
 * サービスメニュー
 * @param serviceMenuViewType
 * @returns
 */
export function convertServiceMenuViewType(
  serviceMenuViewType: ServiceMenuBreakTime,
): number {
  switch (serviceMenuViewType) {
    case ServiceMenuBreakTime.MINUTES_0:
      return 0;
    case ServiceMenuBreakTime.MINUTES_5:
      return 5;
    case ServiceMenuBreakTime.MINUTES_10:
      return 10;
    case ServiceMenuBreakTime.MINUTES_15:
      return 15;
    case ServiceMenuBreakTime.MINUTES_20:
      return 20;
    case ServiceMenuBreakTime.MINUTES_25:
        return 25;
    case ServiceMenuBreakTime.MINUTES_30:
      return 30;
    default:
      assertNever(serviceMenuViewType as never);
  }
}

/**
 * オプションの時間
 * @param serviceMenuOptionTime
 * @returns
 */
export function convertServiceMenuOptionTime(
  serviceMenuOptionTime: ServiceMenuOptionTime,
): number {
  switch (serviceMenuOptionTime) {
    case ServiceMenuTimeRequired.MINUTES_15:
      return 15;
    case ServiceMenuTimeRequired.MINUTES_30:
      return 30;
    case ServiceMenuTimeRequired.MINUTES_45:
      return 45;
    case ServiceMenuTimeRequired.MINUTES_60:
      return 60;
    case ServiceMenuTimeRequired.MINUTES_75:
      return 75;
    case ServiceMenuTimeRequired.MINUTES_90:
      return 90;
    case ServiceMenuTimeRequired.MINUTES_120:
      return 120;
    case ServiceMenuTimeRequired.MINUTES_150:
      return 150;
    case ServiceMenuTimeRequired.MINUTES_180:
      return 180;
    case ServiceMenuTimeRequired.MINUTES_210:
      return 210;
    case ServiceMenuTimeRequired.MINUTES_20:
      return 20;
    case ServiceMenuTimeRequired.MINUTES_25:
      return 25;
    case ServiceMenuTimeRequired.MINUTES_35:
      return 35;
    case ServiceMenuTimeRequired.MINUTES_40:
      return 40;
    case ServiceMenuTimeRequired.MINUTES_50:
      return 50;
    case ServiceMenuTimeRequired.MINUTES_55:
      return 55;
    case ServiceMenuTimeRequired.MINUTES_70:
      return 70;
    case ServiceMenuTimeRequired.MINUTES_80:
      return 80;
    case ServiceMenuTimeRequired.MINUTES_100:
      return 100;
    case ServiceMenuTimeRequired.MINUTES_240:
      return 240;
    case ServiceMenuTimeRequired.MINUTES_300:
      return 300;
    case ServiceMenuTimeRequired.MINUTES_0:
      return 10;
    default:
      assertNever(serviceMenuOptionTime);
  }
}
